var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13.1558,
    r: 12.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 13.8225C11.9543 14.2052 12.3195 14.5219 12.739 14.7511C13.1585 14.9803 13.6223 15.1166 14.0991 15.1507C14.5758 15.1849 15.0544 15.1161 15.5022 14.949C15.95 14.782 16.3567 14.5205 16.6946 14.1825L18.6946 12.1825C19.3018 11.5538 19.6378 10.7118 19.6302 9.83782C19.6226 8.96383 19.2721 8.12779 18.654 7.50976C18.036 6.89173 17.2 6.54117 16.326 6.53357C15.452 6.52598 14.61 6.86196 13.9813 7.46915L12.8346 8.60915",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3335 12.4891C14.0472 12.1063 13.6819 11.7896 13.2624 11.5605C12.843 11.3313 12.3791 11.195 11.9024 11.1609C11.4256 11.1267 10.9471 11.1955 10.4992 11.3626C10.0514 11.5296 9.64472 11.791 9.3068 12.1291L7.3068 14.1291C6.69961 14.7578 6.36363 15.5998 6.37122 16.4738C6.37881 17.3477 6.72938 18.1838 7.3474 18.8018C7.96543 19.4198 8.80147 19.7704 9.67546 19.778C10.5495 19.7856 11.3915 19.4496 12.0201 18.8424L13.1601 17.7024",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy-link.d22df3d098251b655ce3621e60ab789a.svg";
export { ForwardRef as ReactComponent };